import React, { Component } from "react";
import Helmet from "react-helmet";
import Basic from '../scripts/basic';
import { NavLink } from 'react-router-dom';
import axios from 'axios';

export default class Blog extends Component {
  state = {
    blog: [],
    isLoading: true,
  }
  componentDidMount(){
    axios.get('https://weareoneseven.com/wp-json/seventool/v1/blog') 
    .then(res => {
      const blog = res.data.posts;
      this.setState({ 
        blog: blog, 
        isLoading: false
      })
    }).catch(error => {
      console.log(this);
    })
  }
  render() {
    let blog;
    if(this.state.isLoading){
      blog = "Content is loading...";
    } else {
      if(this.state.blog !== false){
        blog = this.state.blog.map((item, i) => {
          return(
            <div className="blog-post" key={item.id}>
              <div className="grid-x grid-padding-x grid-margin-x align-middle">
                <div className="large-3 cell">
                  <img src={item.thumbnail ? item.thumbnail : '//placehold.it/350x400/000000?text=7-Tool Advisor'} alt={item.title + " thumbnail"} />
                </div>
                <div className="large-9 cell">
                  <div className="blog-meta">
                    <h2>{item.title}</h2>
                    <h3><i className="lmg-fas lmg-fa-calendar-alt"></i>Posted on {item.date} by {item.author_name}</h3>
                  </div>
                  <div className="blog-excerpt">
                    <p dangerouslySetInnerHTML={{__html: item.excerpt}} />
                    <p><NavLink to={"/blog/" + item.slug} className="button">Continue Reading</NavLink></p>
                  </div>
                </div>
              </div>
            </div>
          )
        })
      }
    }
    return (
      <div>
      <div className="transition-overlay"></div>
        <Basic/>
        <Helmet>
          <title>Blog | 7-Tool Advisor by One Seven</title>
          <meta property="og:image" content="https://7tooladvisor.com/images/transition-header.jpg" />
        </Helmet>
        <div className="pageContent">
          <div className="innerContent">
            <div className="wrap">
              <div className="titleContainer">
                <div className="bg-wrapper culture-header"></div>
                <div className="bg-flex-wrapper" dangerouslySetInnerHTML={{__html: this.props.bg}} />
                <h1>
                  Our Blog
                </h1>
                <i className="arrow-down lmg-fal lmg-fa-chevron-down animated flash"></i>
              </div>
              <div className="int-tier" id="tier1">
                <div className="wrap">
                  {blog}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
